/* eslint-disable react/function-component-definition */
/* eslint-disable import/no-unresolved */
import { useFormik } from "formik";
import { FC, memo, useEffect, useState } from "react";
import { MedicalQuestionnaireAPIData } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import {
  calcAgeFromToday,
  constructFormikProps
} from "src/helpers/FormDetails/ProposalDetails/resources";
import { setStepDetails } from "src/redux/Actions/common";
import store from "src/redux/store";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import ReviewHeading from "src/shared/ReviewHeading";
import CustomButton from "src/shared/CustomButton";
import UWQuestionnaire from "../../../../shared/UWQuestionnaire";

interface Props {
  showButtons?: boolean;
}

const MedicalAndLifeStyleV2: FC<Props> = ({ showButtons }) => {
  const questionnaire: MedicalQuestionnaireAPIData.QuestionnaireReducer = useAppSelector(
    (state) => state?.masterdata_reducer?.questionnaire
  );
  const gender = useAppSelector((state) => state.proposerDetails?.general?.genderCode) || "";
  const reviewStepNumber = useAppSelector((state): any => state?.stepDetails?.reviewStepNo);
  const [formikProperties, setFormikProperties] = useState<Record<string, any>>({
    initialValues: {},
    validationSchema: null
  });
  const [errorJSON, setErrorJSON] = useState<Record<string, any>>({});
  const medicalLifeStyleV2Data = useAppSelector(
    (state) => state?.medicalAndLifeStyle?.medicalDetailsV2
  );
  const sumAssured = useAppSelector((state) => state?.common?.leadDetails?.sumAssured);
  const primaryLifeDob = useAppSelector((state) => state?.proposerDetails?.general?.dob) || "";
  const age = calcAgeFromToday(primaryLifeDob);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: formikProperties?.initialValues || {},
    ...(formikProperties?.validationSchema && {
      validationSchema: formikProperties?.validationSchema
    })
  });

  useEffect(() => {
    const { initialValues, validationSchema } = constructFormikProps(
      questionnaire,
      { gender, sumAssured, age },
      medicalLifeStyleV2Data!
    );
    console.log("setting initial values", initialValues);
    formik.setValues(initialValues);
    setFormikProperties({ initialValues, validationSchema });
  }, [medicalLifeStyleV2Data, questionnaire]);

  const onBack = () => {
    store.dispatch(setStepDetails({ reviewStepNo: reviewStepNumber - 1 }));
    window.scrollTo(0, 0);
  };

  const onNext = () => {
    store.dispatch(setStepDetails({ reviewStepNo: reviewStepNumber + 1 }));
    window.scrollTo(0, 0);
  };

  return (
    <div className="  font-montserrat">
      <div className="xl:ml-10 xl:mr-10 lg:ml-10 lg:mr-10 md:ml-10 md:mr-10 ml-4 mr-4">
        <ReviewHeading label="Medical & LifeStyle" />
      </div>
      <UWQuestionnaire
        formik={formik}
        errorJSON={errorJSON}
        setErrorJSON={setErrorJSON}
        editable={false}
      />
      {showButtons && (
        <div className="pb-10">
          <CustomButton onBack={onBack} onNext={onNext} />
        </div>
      )}
    </div>
  );
};

MedicalAndLifeStyleV2.defaultProps = {
  showButtons: true
};

export default memo(MedicalAndLifeStyleV2);
